import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	SWITCH_IPV4_ACL_FILTER_EVENT,
	SWITCH_IPV4_ACL_FOCUS_EVENT,
	SWITCH_IPV4_ACL_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.switch_ipv4_acls']);

/**
 * Open Access Controls and bring Switch IPv4 ACL into view.
 *
 * Five collections share this one accordion, and two of them are behind an
 * inner tab pair, so the section is named per collection rather than per
 * accordion - the page selects the tab when it needs to.
 *
 * @return {Promise<void>} completion acknowledgement
 */
export function openSwitchIpv4AclSection() {
	return openResourceSection(
		SWITCH_IPV4_ACL_SECTION_EVENT,
		'profile.switch_ipv4_acls',
		SECTIONS,
	);
}

/**
 * Filter the Switch IPv4 ACL table to a search term.
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applySwitchIpv4AclFilter(query) {
	return dispatchAcknowledgedEvent(SWITCH_IPV4_ACL_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'switch_ipv4_acl',
	});
}

/**
 * Point at one Switch IPv4 ACL row in the table.
 * @param {string} entityId identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusSwitchIpv4Acl(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_switch_ipv4_acl_focus'));
	return dispatchAcknowledgedEvent(SWITCH_IPV4_ACL_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'switch_ipv4_acl',
	});
}
